import { render, staticRenderFns } from "./SelectParent.vue?vue&type=template&id=b0f94c7e&scoped=true&"
import script from "./SelectParent.vue?vue&type=script&lang=js&"
export * from "./SelectParent.vue?vue&type=script&lang=js&"
import style0 from "./SelectParent.vue?vue&type=style&index=0&id=b0f94c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f94c7e",
  null
  
)

export default component.exports